// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import MDButton from "components/MDButton";

// Images
import { useEffect, useState } from "react";

export default function PendingOffersTableData(onActionClick, searchText, pendingOffers, token) {
  const [timeNow, setTimeNow] = useState(Math.floor(Date.now() / 1000))

  function getStatusColor(status){
    if(status === "in progress"){
      return "dark"
    }
    if(status === "accepted"){
      return "success"
    }
    if(status === "rejected"){
      return "error"
    }
  }

  function handleActionClick(offer){
    onActionClick(offer)
  }

  useEffect(() => {
    setInterval(() => {
      setTimeNow(Math.floor(Date.now() / 1000));
    }, 1000);
  });

  function getFromLocalStorage(imageId){
    let data =  localStorage.getItem(imageId);
    return 'data:image/png;base64,' + data;
  }

  const User = ({ imageId, name, level }) => (
      
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar src={getFromLocalStorage(imageId)} size='lg'></MDAvatar>
        <MDBox ml={2} lineHeight={1}>
          <MDTypography display="block" variant="button" fontWeight="medium">
            {name}
          </MDTypography>
          <MDTypography variant="caption">{"Level " + level}</MDTypography>
        </MDBox>
      </MDBox>

  );

  const Product = ({ title, properties }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {title}
      </MDTypography>
      {Object.keys(properties).map((property_key) => (
        <MDBox lineHeight={1} key={property_key} >
          <MDTypography variant="caption">{property_key+": "+properties[property_key]}
          </MDTypography>
        </MDBox>
        ))}
    </MDBox>
  );

  function getRows(offers){
    if(offers === null){
      return []
    }
    offers = offers['data']
    if(offers.length === 0){
      return []
    }
    const filteredOffer = offers.filter((offer) => {
      const searchTextUpperCase = searchText.toUpperCase()
      if(offer['barcode'].includes(searchTextUpperCase)){
        return true;
      }
      return false;

    })
    return filteredOffer.map((offer) => (
              {
                code: (
                  <MDTypography variant="caption" color="text" fontWeight="medium">
                    {offer['barcode']}
                  </MDTypography>
                ),
                user: <User imageId={offer['avatar']['photo_id']} name={offer['avatar']['nickname']} level={offer['avatar']['level']}/>,
                product: <Product title={offer['product']['product_name']} properties={offer['product']['product_properties']} />,
                date: (
                  <>
                    <MDTypography variant="caption" color="error" fontWeight="medium" mr={5}>
                      {offer['expiration_1'] - timeNow < 0 ? 
                        "00:00" 
                        :
                        parseInt(((offer['expiration_1'] - timeNow)%3600)/60).toString().padStart(2, '0') + ":"+ ((offer['expiration_1']- timeNow)%60).toString().padStart(2, '0')
                      }
                    </MDTypography>
                    <MDTypography  variant="caption" color="warning" fontWeight="medium">
                    {offer['expiration_2'] - timeNow < 0 ? 
                        "00:00" 
                        :
                        parseInt(((offer['expiration_2'] - timeNow)%3600)/60).toString().padStart(2, '0') + ":"+ ((offer['expiration_2'] - timeNow)%60).toString().padStart(2, '0')
                    }
                    </MDTypography>
                  </>
                ),
                action: (
                  <MDButton  onClick={() => handleActionClick(offer)}>
                    <MDBadge badgeContent={"View deal"} color={getStatusColor(offer.status)} variant="gradient" size="lg" />
                  </MDButton>
                )
              }
    ))

  }

  return {
    columns: [
      { Header: "offer barcode", accessor: "code", width: "10%", align: "left" },
      { Header: "", accessor: "user", width: "20%", align: "left" },
      { Header: "", accessor: "product", width: "20%", align: "left" },
      { Header: "expiration timers", accessor: "date", width: "30%", align: "center" },
      { Header: "status", accessor: "status",  width: "10%", align: "center" },
      { Header: "", accessor: "action", width: "10%", align: "center" },
    ],

    pendingRows: getRows(pendingOffers),
  }
}
